"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldReleaseFileOperationLock = exports.isCatalogWorkflowActive = exports.shouldShowCatalogContent = exports.shouldShowFullScreenLockout = void 0;
const catalog_models_1 = require("../client/catalog/catalog.models");
const shouldShowFullScreenLockout = ({ isFileOperationBlocking, isUploadInProgress, }) => isFileOperationBlocking || isUploadInProgress;
exports.shouldShowFullScreenLockout = shouldShowFullScreenLockout;
const shouldShowCatalogContent = (catalogProgressState, isFullScreenLockoutVisible) => !isFullScreenLockoutVisible && catalogProgressState !== catalog_models_1.CatalogProgressState.NotStarted;
exports.shouldShowCatalogContent = shouldShowCatalogContent;
const isCatalogWorkflowActive = (catalogProgressState) => ![
    catalog_models_1.CatalogProgressState.NotStarted,
    catalog_models_1.CatalogProgressState.Completed,
].includes(catalogProgressState);
exports.isCatalogWorkflowActive = isCatalogWorkflowActive;
const shouldReleaseFileOperationLock = (hasObservedCatalogActivity, catalogProgressState, hasCatalogActivityError) => !hasCatalogActivityError
    && hasObservedCatalogActivity
    && catalogProgressState === catalog_models_1.CatalogProgressState.Completed;
exports.shouldReleaseFileOperationLock = shouldReleaseFileOperationLock;
